import { Link } from 'react-router-dom';
import { manualSectionPath } from '../../../helpers/manualPath';
import { VOUCH_COPY } from '../vouch.copy';
import './VouchHowItWorks.scss';

/**
 * Slim orientation box on /vouch (TRIL-426). The full vouching explainer lives
 * at /readme/vouching (TRIL-422) — this keeps just the co-signer caveat that
 * matters where a user stakes credits, then links out to the manual. The header
 * already carries a <ManualLink> help icon; this is the inline teaser + link.
 */
export function VouchHowItWorks() {
  return (
    <aside className="vouch-how">
      <h3 className="vouch-how__title">{VOUCH_COPY.blurb.title}</h3>
      <p className="vouch-how__body">{VOUCH_COPY.blurb.body}</p>
      <Link className="vouch-how__link" to={manualSectionPath('vouching')}>
        {VOUCH_COPY.blurb.fullGuide}
        <span aria-hidden="true"> →</span>
      </Link>
    </aside>
  );
}
